import { FunctionComponent } from 'react'
import { useSettings } from '../hooks/useSettings'
import Modal, { ModalComponentProps } from './Modal'
import Switch from './Switch'

type ModalSettingsProps = {
	// settings: Settings
} & ModalComponentProps

const ModalSettings: FunctionComponent<ModalSettingsProps> = props => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { ...otherProps } = props

	const settings = useSettings()
	const showClock = settings.getShowClock()
	const effectiveDarkMode = settings.getEffectiveDarkMode()

	// Cycle through different modes
	const handleDarkModeToggle = () => {
		settings.setDarkMode(!effectiveDarkMode)
	}

	return (
		<Modal popup title="Settings" name="settings" {...otherProps}>
			<Switch
				label="Show clock"
				checked={showClock}
				onChange={() => settings.setShowClock(!showClock)}
			/>
			<br />
			<Switch label="Dark mode" checked={effectiveDarkMode} onChange={handleDarkModeToggle} />
		</Modal>
	)
}
export default ModalSettings
